module.exports = __webpack_public_path__ + "img/img62.2288f49d.svg";